<template>
  <div>
    <div class="header">
      <date-filter @onDateChanged="onDateChanged" />
      <vs-row
        v-if="tables && Array.isArray(tables) && tables.length > 0"
        class="tables-wrapper"
      >
        <vs-col vs-justify="center" vs-align="center" vs-w="12" class="p-0">
          <h6 class="mb-3">لیست شماره میزها</h6>
          <div style="display: flex; gap: 8px">
            <vs-select
              v-model="selectedTable"
              width="100%"
              @input="handleSelectedTable"
            >
              <vs-select-item
                v-for="(table, index) in tables"
                :value="table"
                :text="`${table.title}`"
                :key="index"
                icon="arrow_downward"
              />
            </vs-select>
            <vs-button
              v-if="selectedTable"
              style="padding: 0; min-width: 70px"
              size="small"
              color="danger"
              @click="resetTables"
              >حذف فیلتر</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </div>

    <div class="tabs-wrapper">
      <vs-tabs v-if="showTabs" alignment="fixed" v-model="defaultTab">
        <vs-tab label="سفارشات جدید" @click="handleClickTab(0)">
          <unlimited-list
            ref="unlimitedList"
            :fetch-page="fetchPendingOrdersPage"
          >
            <template v-slot:default="props">
              <vs-col vs-w="6" vs-sm="12">
                <order
                  :order="props.item"
                  :index="props.index"
                  @refreshList="refreshList"
                ></order>
              </vs-col>
            </template>
          </unlimited-list>
        </vs-tab>
        <vs-tab label="سفارشات بررسی شده" @click="handleClickTab(1)">
          <unlimited-list :fetch-page="fetchDoneOrdersPage" ref="unlimitedList">
            <template v-slot:default="props">
              <vs-col vs-w="6" vs-sm="12">
                <order
                  :order="props.item"
                  :index="props.index"
                  @refreshList="refreshList"
                ></order>
              </vs-col>
            </template>
          </unlimited-list>
        </vs-tab>
        <vs-tab label="در انتظار پرداخت" @click="handleClickTab(2)">
          <unlimited-list
            ref="unlimitedList"
            :fetch-page="fetchPaymentRequiredOrdersPage"
          >
            <template v-slot:default="props">
              <vs-col vs-w="6" vs-sm="12">
                <order :order="props.item" :index="props.index"></order>
              </vs-col>
            </template>
          </unlimited-list>
        </vs-tab>
      </vs-tabs>
    </div>
    <vs-button
      v-if="showUpdateButton"
      @click="update()"
      class="refresh-list"
      color="success"
      type="gradient"
      icon-pack="feather"
      icon="icon-refresh-ccw"
      >بروزرسانی لیست</vs-button
    >
    <reports-preview
      ref="reportsPreview"
      v-if="reportsVisible"
      :date="currentDate"
      :receiptCount="receiptCount"
      :tableId="selectedTable && selectedTable.id"
      @resetTables="resetTables"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Order from "./../../components/order/Order.vue";
import orderApiService from "../../services/api/OrderApiService";
import DateFilter from "../../components/DateFilter.vue";
import ReportsPreview from "./ReportsPreview.vue";
import providerApiService from "../../services/api/ProviderApiService";

export default {
  name: "Orders.vue",
  data() {
    return {
      showTabs: true,
      showUpdateButton: false,
      currentDate: null,
      reportsVisible: false,
      receiptCount: 0,
      defaultTab: 0,
      tables: null,
      selectedTable: null,
      timeout: null,
    };
  },
  components: {
    Order,
    DateFilter,
    ReportsPreview,
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  mounted() {
    window.addEventListener("addOrder", this.onNewOrder);
    this.getDefaultTab();
    this.getProviderTables();
  },
  destroyed() {
    window.removeEventListener("addOrder", this.onNewOrder);
    this.timeout = null;
  },
  methods: {
    onNewOrder() {
      this.showUpdateButton = true;
    },
    refreshList() {
      if (this.$refs.unlimitedList) {
        this.$refs.unlimitedList.refresh();
      }
    },
    onDateChanged(date) {
      this.currentDate = date;
      this.refreshList();
    },
    fetchPendingOrdersPage(page = 1) {
      this.reportsVisible = false;
      if (page === 1) this.showUpdateButton = false;
      return orderApiService.getOrders(
        this.currentProvider.id,
        page,
        ["pending"],
        this.currentDate,
        this.selectedTable?.id
      );
    },
    fetchDoneOrdersPage(page = 1) {
      this.reportsVisible = true;
      if (page === 1) this.showUpdateButton = false;
      return orderApiService
        .getOrders(
          this.currentProvider.id,
          page,
          ["approved", "denied"],
          this.currentDate,
          this.selectedTable?.id
        )
        .then((result) => {
          this.receiptCount = result.meta.total;
          return result;
        });
    },
    fetchPaymentRequiredOrdersPage(page = 1) {
      this.reportsVisible = false;
      if (page === 1) this.showUpdateButton = false;
      return orderApiService.getOrders(
        this.currentProvider.id,
        page,
        ["payment_required"],
        this.currentDate
      );
    },
    update() {
      this.showUpdateButton = this.showTabs = false;
      setTimeout(() => {
        this.showTabs = true;
      }, 10);
    },
    handleClickTab(value) {
      localStorage.setItem("orders_default_tab", value);
    },
    getDefaultTab() {
      const tab = localStorage.getItem("orders_default_tab");
      if (tab) {
        setTimeout(() => {
          this.defaultTab = +tab;
        }, 150);
      }
    },
    getProviderTables() {
      providerApiService
        .getProviderTablesList(this.currentProvider.id)
        .then((result) => {
          this.tables = result.data;
        });
    },
    handleSelectedTable(table) {
      this.selectedTable = table;
      this.refreshList();
    },
    resetTables() {
      this.selectedTable = null;
      this.refreshList();
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: flex-start;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}

.tabs-wrapper {
  min-height: calc(100vh - 130px);
}

.refresh-list {
  position: sticky;
  bottom: 5%;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.12),
    0 7px 10px -5px rgba(0, 0, 0, 0.15);
}

.tables-wrapper {
  flex: 0.3;
  margin: 0;
  padding: 0;
  gap: 2px;

  @media screen and (max-width: 768px) {
    flex: 1;
    width: 100% !important;
  }
}

.delete-btns {
  position: sticky;
  bottom: 5%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 1000px) {
    bottom: 5%;
  }

  .delete-btn {
    margin: 4px 0;
    width: 200px;
    box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.12),
      0 7px 10px -5px rgba(0, 0, 0, 0.15);
  }
}
</style>
